<i18n>
{
  "ja": {
    "h-1": "活用事例",
    "lead": "WareXをご利用になった:お客様の活用事例をご紹介いたします。:",
    "button": "活用事例一覧へ"
  }
}
</i18n>

<template>
  <div class="wrap">
    <div class="text-center w-7/8 mx-auto">
      <h2 class="block-header">{{ $t('h-1') }}</h2>
      <p class="ornament-header">Case Study</p>
      <div class="block-lead" v-html="$md.render($t('lead'))" />
    </div>
    <div
      v-if="Array.isArray(articles) && articles.length"
      v-swiper:mySwiper="swiperOption"
      class="swiper-container container w-10/12 mx-auto"
    >
      <div class="swiper-wrapper flex items-stretch pt-12 pb-8">
        <article-card v-for="(article, index) of articles" :key="index"
          class="swiper-slide mx-2 lg:mx-8"
          :article="article"
        />
      </div>
      <div class="swiper-pagination"></div>
    </div>
    <p v-else class="text-center my-10">記事が見つかりませんでした</p>
  </div>
</template>

<style lang="sass" scoped>
.wrap
  background-color: #f4f4f4
  color: #333
  @apply py-16 overflow-hidden
  @screen md
    @apply pt-20 pb-24
.ornament-header
  @apply text-current
::v-deep
  span
    @apply inline-block
.swiper-container
  @apply overflow-visible
.swiper-slide
  max-width: 774px
  @apply h-auto
.swiper-pagination
  @apply relative mt-6
  ::v-deep
    .swiper-pagination-bullet
      @apply mx-2
      height: 12px
      width: 12px
      border-radius: 6px
      transition: width 0.5s
      opacity: 1
      &-active
        @apply w-16
      &:not(.swiper-pagination-bullet-active)
        @apply bg-white
        @screen sm
          @apply bg-black
          opacity: 0.2
</style>

<script>
import ArticleCard from "@/components/case-study/articleCard";
export default {
  components: {
    ArticleCard
  },
  props: {
    articles: { type: Array, required: true }
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 'auto',
        centeredSlides: true,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
          bulletClass: 'swiper-pagination-bullet',
          bulletActiveClass: 'swiper-pagination-bullet-active bg-orange'
        }
      }
    };
  },
  methods: {
    onIntersect(entries) {
      const target = entries.target;
      if(entries.isIntersecting) {
        target.classList.add('isIntersect');
      }
    }
  }
};
</script>
